import { FunctionComponent } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { Location } from "@App/Pages/Common/Location";
import { Brands } from "@App/Pages/Common/Brands";
import { KeyNumber } from "@App/Pages/Common/KeyNumber";
import { Generations } from "@App/Pages/Common/Generations";
import { Motorizations } from "@App/Pages/Common/Motorizations";
import { useServiceFunnel } from "@App/hooks/useServiceFunnel";

/**
 * The funnel for the oilchange service.
 *
 * @constructor
 */
export const Timingbelt: FunctionComponent = () => {
  const { navigateWithQuery } = useServiceFunnel("zahnriemenwechsel");

  return (
    <Routes>
      <Route
        path={"/"}
        element={
          <Brands
            headline={"Zahnriemenwechsel"}
            step={1}
            maxSteps={5}
            onKeyNumberLinkClick={() => navigateWithQuery("hsn-tsn")}
            onSubmit={() => navigateWithQuery(`modell`)}
          />
        }
      />
      <Route
        path={"/modell"}
        element={
          <Generations
            headline={"Zahnriemenwechsel"}
            step={2}
            maxSteps={5}
            onKeyNumberLinkClick={() => navigateWithQuery("hsn-tsn")}
            onSubmit={() => navigateWithQuery(`../motorisierung`, true)}
          />
        }
      />
      <Route
        path={"/motorisierung"}
        element={
          <Motorizations
            headline={"Zahnriemenwechsel"}
            step={3}
            maxSteps={5}
            onKeyNumberLinkClick={() => navigateWithQuery("hsn-tsn")}
            onSubmit={() => navigateWithQuery(`../ort`, true)}
          />
        }
      />
      <Route
        path={"/hsn-tsn"}
        element={
          <KeyNumber
            headline={"Zahnriemenwechsel"}
            step={3}
            maxSteps={5}
            onVehicletreeLinkClick={() => navigateWithQuery("./")}
            onSubmit={() => navigateWithQuery(`../ort`, true)}
          />
        }
      />
      <Route
        path={"/ort"}
        element={
          <Location
            headline={"Zahnriemenwechsel"}
            step={4}
            maxSteps={5}
            onSubmit={() => navigateWithQuery(`../werkstaetten`, true)}
          />
        }
      />
      {/* Redirect old links to funnel beginning */}
      <Route path={"/modellauswahl/*"} element={<Navigate to={"/zahnriemenwechsel"} />} />
    </Routes>
  );
};
